import { BareButton } from '@calendly/ui/components/bare-button';
import { ArrowChevronLeftMiniIcon, ArrowChevronRightMiniIcon } from '@calendly/ui/components/icons';
import classNames from 'classnames';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { DATE_FORMAT } from '../constants';
import { rangeLength } from './utils';
const containerCss = "cpwx4xc";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const arrowDisabledCss = "ablgjob";
const arrowCss = "aldxtef";
const Arrow = forwardRef((props, ref) => {
  const {
    disabled,
    ...restProps
  } = props;
  return <BareButton ref={ref} {...restProps} className={classNames(arrowCss, {
    [arrowDisabledCss]: disabled
  }, props.className)} />;
});
const leftArrowCss = "l1e8p63e";
const LeftArrow = forwardRef((props, ref) => <Arrow ref={ref} {...props} aria-label="Previous week" className={classNames(leftArrowCss, props.className)}>
    <ArrowChevronLeftMiniIcon size="x-large" />
  </Arrow>);
const rightArrowCss = "r18q3nbx";
const RightArrow = forwardRef((props, ref) => <Arrow ref={ref} {...props} aria-label="Next week" className={classNames(rightArrowCss, props.className)}>
    <ArrowChevronRightMiniIcon size="x-large" />
  </Arrow>);
export const Navigators = ({
  goToDate,
  currentView,
  currentRangeStart,
  timezone
}) => {
  const daysRange = rangeLength(currentView);
  const goToNextDate = () => {
    const nextDate = currentRangeStart.clone().add(daysRange, 'days').format(DATE_FORMAT);
    goToDate(nextDate);
  };
  const goToPrevDate = () => {
    const prevDate = currentRangeStart.clone().subtract(daysRange, 'days').format(DATE_FORMAT);
    goToDate(prevDate);
  };
  const isDisabled = moment().tz(timezone).isSameOrAfter(currentRangeStart, 'day');
  return <Container>
      <LeftArrow onClick={goToPrevDate} disabled={isDisabled} />
      <RightArrow onClick={goToNextDate} />
    </Container>;
};
Navigators.propTypes = {
  goToDate: PropTypes.func.isRequired,
  currentView: PropTypes.string.isRequired,
  currentRangeStart: PropTypes.instanceOf(moment).isRequired,
  timezone: PropTypes.string
};

require("./navigators.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./navigators.js");